export default __webpack_public_path__ + "static/media/img-team-advisros-sb3x.aca40c88.png";